import request from '@/utils/request'
// 查询设备数据信息列表
export function listDeviceData(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/list',
    method: 'post',
    data: data
  })
}
// 查询设备数据实时数据
export function chartOne(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/one',
    method: 'post',
    data: data
  })
}
// 查询设备数据历史电位
export function chartTwo(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/two',
    method: 'post',
    data: data
  })
}
// 查询实时交流电压
export function chartThree(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/three',
    method: 'post',
    data: data
  })
}
// 历史交流电压
export function chartFour(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/four',
    method: 'post',
    data: data
  })
}
// 季度电位分析
export function chartFive(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/five',
    method: 'post',
    data: data
  })
}
//管线电位-交流电压分布
export function chartSix(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/six',
    method: 'post',
    data: data
  })
}
//电流分布图
export function chartSeven(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/seven',
    method: 'post',
    data: data
  })
}
// 查询设备数据信息分页
export function pageDeviceData(query) {
  return request({
    url: '/saifuneng/saifuneng-device-data/page',
    method: 'get',
    params: query
  })
}
// 查询分析详情
export function getObj(query) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/protection/analysis/detail',
    method: 'post',
    data: query
  })
}
// 阴极保护中心
export function protectionChart(query) {
  return request({
    url: '/saifuneng/saifuneng-device-data/chart/protection/analysis',
    method: 'post',
    data: query
  })
}

// 查询设备数据信息详细
export function getDeviceData(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/detail',
    method: 'get',
    params: data
  })
}

// 新增设备数据信息
export function addDeviceData(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/add',
    method: 'post',
    data: data
  })
}

// 修改设备数据信息
export function updateDeviceData(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/edit',
    method: 'post',
    data: data
  })
}

// 删除设备数据信息
export function delDeviceData(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/delete',
    method: 'post',
    data: data
  })
}

// 查询管线信息列表
export function listPipeline(query) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/list',
    method: 'get',
    params: query
  })
}

// 查询设备信息列表
export function listDevice(query) {
  return request({
    url: '/saifuneng/saifuneng-device/list',
    method: 'get',
    params: query
  })
}

// 实时电位
export function listChartOne(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/one',
    method: 'get',
    params: query
  })
}
// 历史电位
export function listChartTwo(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/two',
    method: 'get',
    params: query
  })
}
// 实时交流电压
export function listChartThree(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/three',
    method: 'get',
    params: query
  })
}
// 历史交流电压
export function listChartFour(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/four',
    method: 'get',
    params: query
  })
}
// 季度电位分析
export function listChartFive(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/five',
    method: 'get',
    params: query
  })
}
// 管线电位/交流电压分布
export function listChartSix(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/six',
    method: 'get',
    params: query
  })
}
// 电流分布图
export function listChartSeven(query) {
  return request({
    url: '/saifuneng/saifuneng-device/chart/seven',
    method: 'get',
    params: query
  })
}

// 查询设备数据信息分页
export function pageDeviceDataTdengine(query) {
  return request({
    url: '/saifuneng/saifuneng-device-data/tdengine/page',
    method: 'get',
    params: query
  })
}

// 批量修改位置信息
export function deviceDataBatchAddressEdit(data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/batch/address/edit',
    method: 'post',
    data: data
  })
}

// 设备数据
export function listChart(query) {
  return request({
    url: '/saifuneng/saifuneng-device-data/tdengine/chart',
    method: 'post',
    data: query
  })
}
